import { CategoryImpact } from 'app/model/redshift/impact-report/category-impact';
import { ChannelImpact } from 'app/model/redshift/impact-report/channel-impact';
import { StoreImpact } from 'app/model/redshift/impact-report/store-impact';

export interface SavedReports {
    category: CategoryImpact[];
    channel: ChannelImpact[];
    store: StoreImpact[];
}

export const createEmptySave = (): SavedReports => ({ category: [], channel: [], store: [] });
